<template><div><h1 id="ereignisauswertung-kumuliert-nach-zeitraum" tabindex="-1"><a class="header-anchor" href="#ereignisauswertung-kumuliert-nach-zeitraum"><span>Ereignisauswertung kumuliert nach Zeitraum</span></a></h1>
<p>Ereignisauswertung kumuliert nach Zeitraum — Anzahl und Wert der Responses auf ein Ereignis</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung zeigt Anzahl und Wert der Responses auf bestimmte Ereignisse an. Eingeschränkt werden kann zusätzlich nach Zeitraum Zahlungseingang von - Zahlungseingang bis und bestimmten Ereignissituation(en). Die Statistik liefert das Ergebnis pro Ereignis separat oder kumuliert. Die Sortierung der Liste ist nach Ereignisnummer oder Konto/Kst/Ktr möglich.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Ereignisauswertung kumuliert nach Zeitraum</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Ereignis-ID(s)</dt>
<dd>Auszuwertende Ereignisse, Auswahl aus der Wertetabelle</dd>
<dt>Ereignissituation(en)</dt>
<dd>Auszuwertende Ereignissituationen, Auswahl aus der Wertetabelle</dd>
<dt>Zahlungseingang von</dt>
<dd>Einschränkung der Zahlungen nach Zeitraum (von Datum)</dd>
<dt>Zahlungseingang bis</dt>
<dd>Einschränkung der Zahlungen nach Zeitraum (bis Datum)</dd>
<dt>Anzeige Ereignisse</dt>
<dd>Bei Auswahl <span class="guilabel">einzeln</span> wird jedes passende Ereignis einzeln aufgeführt, bei Auswahl <span class="guilabel">alle zusammen</span> werden nur die Summen ausgewiesen.</dd>
<dt>Sortierung nach</dt>
<dd>Ereignisnummer oder Konto/Kst/Ktr.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Ereignis</td>
<td>Ereignis</td>
</tr>
<tr>
<td>Beschreibung</td>
<td>Ereignisbeschreibung</td>
</tr>
<tr>
<td>Sit.</td>
<td>Ereignissituation</td>
</tr>
<tr>
<td>Typ</td>
<td>Ereignistyp</td>
</tr>
<tr>
<td>Konto</td>
<td>Konto des Ereignisses</td>
</tr>
<tr>
<td>Kostenstelle</td>
<td>Kostenstelle des Ereignisses</td>
</tr>
<tr>
<td>Kostenträger</td>
<td>Kostenträger des Ereignisses</td>
</tr>
<tr>
<td>Anzahl Adressen</td>
<td>Anzahl Adressen mit Responses auf das Ereignis</td>
</tr>
<tr>
<td>Anzahl Respons</td>
<td>Anzahl der Responses auf das Ereignis</td>
</tr>
<tr>
<td>Respons Wert</td>
<td>Gesamtwert der Responses auf das Ereignis.</td>
</tr>
</tbody>
</table>
<p>Em Ende der Auswertung werden noch die Summen über alle Ereignisse ausgewiesen.</p>
</div></template>


